import * as React from 'react';
import * as styles from './styles.css';

import { UIHeading4 } from '@cian/ui-kit';

import { IconActionArrowRight16 } from '@cian/ui-kit-design-tokens/icons';

interface ISpecialListCardProps {
  onClick(): void;
}

export const SpecialListCard: React.FC<ISpecialListCardProps> = ({ onClick }) => {
  return (
    <div className={styles['container']} onClick={onClick}>
      <UIHeading4>Вернуться в Мой дом</UIHeading4>
      <IconActionArrowRight16 color="icon-secondary-default" />
    </div>
  );
};

SpecialListCard.displayName = 'SpecialListCard';
